import { IkasRaffle } from ".";
import { initIkasProduct } from "../product/init";

export function initIkasRaffle(raffle: IkasRaffle, locale: string | null) {
  raffle.products?.map((p) => initIkasProduct(p, locale));
}
